var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStreak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 127.99999,
    viewBox: "0 0 120.47141 66.06594",
    id: "SVGRoot",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs277"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-15.000076,-1.0000009)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.88237,
      strokeLinecap: "round",
      paintOrder: "markers stroke fill"
    },
    id: "rect1",
    width: 120.47141,
    height: 120.47141,
    x: 15.000076,
    y: -26.202732,
    ry: 1.0449229e-16
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    d: "M 64.099803,-19.527439 H 86.118732 L 78.779089,9.8311337 106.30276,4.3264014 65.934713,86.897386 78.779089,26.34533 51.255427,35.519884 Z",
    id: "path516"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStreak);
export default __webpack_public_path__ + "static/media/icon_streak.b684eb9492089c3e0314875d9e2cb899.svg";
export { ForwardRef as ReactComponent };